import cn from 'classnames';
import Image from 'next/future/image';
import { useState } from 'react';
import { PimProductT } from '@lambda/apis/src/dynamoDb/types';
import chevronRight from '@/public/icons/product/chevronRight.svg';

const SpecificationSlideDown = ({
  specifications,
}: {
  specifications: { key: string; value: string }[];
  product: PimProductT;
}) => {
  const [show, setShow] = useState(false);
  const [shouldShowSeeMore, setShouldShowSeeMore] = useState(
    specifications.length > 10,
  );

  const slicedSpecifications = shouldShowSeeMore
    ? specifications.slice(0, 7)
    : specifications;

  const toggleSpecifications = () => {
    setShow(!show);
  };

  return (
    <div className="border-b border-gray-200 text-sm last:border-b-0">
      <button
        type="button"
        onClick={() => toggleSpecifications()}
        className="flex w-full items-center justify-between p-4"
      >
        <h3 className="font-bold">Specifications</h3>
        <div
          className={cn('h-3 w-3', {
            'rotate-90': !show,
            'rotate-[270deg]': show,
          })}
        >
          <Image
            src={chevronRight}
            alt="Chevron Right"
            className="h-full w-full"
            height={25}
            width={25}
          />
        </div>
      </button>
      <div
        className={cn('overflow-auto transition-all duration-500 ease-in-out', {
          // We need a number in order for the animation to work.
          'max-h-[2500px]': show,
          'max-h-0': !show,
        })}
      >
        {slicedSpecifications.map((item, index) => (
          <div
            className="px-4 py-2 odd:bg-gray-100"
            key={`${item.key}_${index}`}
          >
            <h4 className="font-bold">{item.key}</h4>
            <div>
              {item.value
                .split('\\n')
                .filter(Boolean)
                .map((v, i) => (
                  <span className="block" key={`specifications_value_${i}`}>
                    {v}
                  </span>
                ))}
            </div>
          </div>
        ))}
        {specifications.length > 10 && (
          <button
            type="button"
            onClick={() => setShouldShowSeeMore(!shouldShowSeeMore)}
            className="px-4 py-2 text-[#0D6EFD] underline"
          >
            See {shouldShowSeeMore ? 'More' : 'Less'}
          </button>
        )}
      </div>
    </div>
  );
};

export default SpecificationSlideDown;
